module.exports = __webpack_public_path__ + "static/img/gifts.e3a4c155.png";